//moment(new Date()).format("Do MMMM")
export const addExistingAction = (data) => {
    return (dispatch, getState, { getFirebase }) => {
      const firestore = getFirebase().firestore();
      //console.log(data);
      firestore
        .collection("applications")
        .add(
          data
        )
        .then(() => {
          dispatch({
            type: "ADD_EXISTING",
            success: true
          });
        })
        .catch((err) => {
          dispatch({
            type: "ADD_EXISTING_ERR",
            err
          });
        });
    };
  };
  